<template>
    <div data-component="OrderPreviewLine"
         class="order-preview-line">
        <div class="order-preview-line__summary">
            {{ line.quantity }} x {{ line.item.name }} <span v-if="showPrice">{{ currencyFilter(line.getLineTotal()) }}</span>
        </div>
        <div v-if="askEarlyInstancesWithValue.length > 0"
             class="cart-item-details">
            <div v-for="itemInstance in askEarlyInstancesWithValue"
                 :key="itemInstance.ID"
                 class="cart-item-details__group">
                <div v-for="fieldInstance in itemInstance.fields.getAskEarlyInstancesWithValue()"
                     :key="fieldInstance.key"
                     class="cart-item-details__detail">
                    {{ fieldInstance.getDisplayValue(true) }}
                </div>
            </div>
        </div>

        <div v-if="nonAskEarlyInstancesWithValue.length > 0"
             class="cart-item-details">
            <div v-for="(itemInstance, index) in nonAskEarlyInstancesWithValue"
                 :key="itemInstance.ID"
                 class="cart-item-details__group">
                <strong class="cart-item-details__detail cart-item-details__detail--clear">#{{ (index + 1) }}:</strong>
                <div v-for="fieldInstance in itemInstance.fields.getNonAskEarlyInstancesWithValue()"
                     :key="fieldInstance.key"
                     class="cart-item-details__detail">
                    <span v-if="fieldInstance.hasValue">
                        <strong>{{ fieldInstance.field.getShortName() }}:</strong>
                        {{ fieldInstance.getDisplayValue(true) }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'OrderPreviewLine',

    props: {
        line: {
            type: Object,
            required: true,
        },
        showPrice: {
            type: Boolean,
            required: false,
            default: true,
        },
    },

    computed: {
        askEarlyInstancesWithValue() {
            return this.line.itemInstances.filter((ii) => {
                return ii.instance === 1 && ii.fields.getAskEarlyInstancesWithValue().length > 0;
            });
        },

        nonAskEarlyInstancesWithValue() {
            return this.line.itemInstances.filter((ii) => {
                return ii.fields.getNonAskEarlyInstancesWithValue().length > 0;
            });
        },
    },
};
</script>

<style lang="less">
@import (less, reference) "../../../../less/mixins.less";
@import (less, reference) "../../../../less/variables.less";

.order-preview-line {
    align-items: center;
    .transition-all();
    padding: @gutter-width-narrow;

    &:not(:last-child) {
        border-bottom: 1px solid @btn-default-border;
    }

    .cart-item-details__group {
        display: block;
        white-space: nowrap;
        overflow: hidden;
    }
}

.order-preview-line__summary {
    display: flex;
    justify-content: space-between;
}

.order-preview-line__detail {
    font-size: 13px;
    margin: 3px 1px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    white-space: normal;

    span {
        display: inline-block;
        padding: 0 6px;
        margin: 2px;
        background: @mid-grey;
        line-height: 22px;
        vertical-align: middle;
        border-radius: @border-radius-base;
    }
}
</style>
